import React from 'react';
import Avatar from 'src/components/Avatar';
import Tenant from 'src/components/Tenant';
import FontAwesomeIcon from 'src/components/Icon';
import { CanonicalContact } from 'src/pages/ServiceRequest/ContactPicker/helpers/contactShape';
import './selected-contact-display.scss';

export type SelectedContactSubtitleVariant = 'role-only' | 'role-and-services';

interface SelectedContactDisplayProps {
  contact: CanonicalContact | null;
  subtitleVariant: SelectedContactSubtitleVariant;
  readOnly?: boolean;
  onClear?: () => void;
}

const buildAvatarBadge = (
  contact: CanonicalContact
): 'service-provider' | 'property-manager' => {
  if (
    contact.role === 'Service Provider' ||
    contact.role === 'Service Manager'
  ) {
    return 'service-provider';
  }

  return 'property-manager';
};

const buildStrapline = (
  contact: CanonicalContact,
  subtitleVariant: SelectedContactSubtitleVariant
): string => {
  if (subtitleVariant !== 'role-and-services') {
    return contact.role;
  }

  if (contact.servicesProvided.length === 0) {
    return contact.role;
  }

  return `${contact.role} - ${contact.servicesProvided.join(', ')}`;
};

export const SelectedContactDisplay = ({
  contact,
  subtitleVariant,
  readOnly = false,
  onClear,
}: SelectedContactDisplayProps) => {
  if (!contact) {
    return (
      <div className="selected-contact-display">
        <div className="selected-contact-display-placeholder">
          No new contact assignment selected yet.
        </div>
      </div>
    );
  }

  return (
    <div className="selected-contact-display is-selected">
      <div className="selected-contact-display-body">
        <Tenant
          headline={contact.fullName}
          strapline={buildStrapline(contact, subtitleVariant)}
          strapLineItemsListRole={contact.role}
          strapLineItemsList={contact.servicesProvided}
          avatar={
            <Avatar
              badge={buildAvatarBadge(contact)}
              url={contact.profileImage}
              size={undefined}
            />
          }
          company={contact.companyName}
        />
      </div>

      {!readOnly && onClear && (
        <button
          type="button"
          className="selected-contact-display-clear"
          title="Clear selection"
          aria-label="Clear selection"
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            onClear();
          }}
        >
          <FontAwesomeIcon glyph="times" weight="light" />
        </button>
      )}
    </div>
  );
};

export default SelectedContactDisplay;
